import { default as statistics } from ":src/modules/analysis/statistics/routes";
import { default as faq_inquiry } from ":src/modules/help-portal/faq-inquiry/routes";
import { default as profile } from ":src/modules/account/profile/routes";
export default {
  BASE: "/auditor",
  statistics,
  faq_inquiry,
  profile,
};
